import R from 'app/assets/R'
import { SvgMedicalExaminationFocusIcon } from 'app/assets/svg-assets'
import { FunctionPermissionEnum } from 'app/common/permission-module'
import { IGroupReport } from 'app/components/common/BaseLayoutReport/type'
import {
  DENTAL_TREATMENT_MANAGEMENT_APPROVE_TREATMENT_FLOW_PATH,
  DENTAL_TREATMENT_MANAGEMENT_APPROVE_TREATMENT_PLAN_PATH,
  DENTAL_TREATMENT_MANAGEMENT_APPROVE_TREATMENT_STAGE_PATH,
  DENTAL_TREATMENT_MANAGEMENT_MEDICAL_RECORD_AND_INFORMATION,
  DENTAL_TREATMENT_MANAGEMENT_PATIENT_SEARCH_PATH,
  DENTAL_TREATMENT_PATIENT_ORTHODONTIC_WITHOUT_PAID_PATH,
  DENTAL_TREATMENT_PATIENT_RECORD_MANAGEMENT,
  DENTAL_TREATMENT_PATIENT_SCHEDULE_WITHOUT_PAID,
} from 'app/components/router/route-path'
import { DateUtil } from 'parkway-web-common'

export const data: IGroupReport[] = [
  {
    id: 1,
    titleI18nKey: R.strings.dental_treatment_management,
    icon: <SvgMedicalExaminationFocusIcon />,
    pages:[
      {
        id: 11,
        label: '001',
        labelI18nKey: R.strings.patient_record_management,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: DENTAL_TREATMENT_PATIENT_RECORD_MANAGEMENT,
        isHideLabel: true,
      },
      {
        id: 12,
        label: '002',
        labelI18nKey: R.strings.approve_flow,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: DENTAL_TREATMENT_MANAGEMENT_APPROVE_TREATMENT_FLOW_PATH,
        isHideLabel: true,
      },
      {
        id: 13,
        label: '003',
        labelI18nKey: R.strings.approve_treatment_plan,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: DENTAL_TREATMENT_MANAGEMENT_APPROVE_TREATMENT_PLAN_PATH,
        isHideLabel: true,
      },
      {
        id: 14,
        label: '004',
        labelI18nKey: R.strings.approve_treatment_phase,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: DENTAL_TREATMENT_MANAGEMENT_APPROVE_TREATMENT_STAGE_PATH,
        isHideLabel: true,
      },
      {
        id: 15,
        label: '005',
        labelI18nKey: R.strings.patient_search,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: DENTAL_TREATMENT_MANAGEMENT_PATIENT_SEARCH_PATH,
        permission: FunctionPermissionEnum.READ_PATIENT_SEARCH,
        isHideLabel: true,
      },
      {
        id: 16,
        label: '006',
        labelI18nKey: R.strings.medical_record_and_information,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: DENTAL_TREATMENT_MANAGEMENT_MEDICAL_RECORD_AND_INFORMATION,
        isHideLabel: true,
      },
    ],
  },
  {
    id: 2,
    titleI18nKey: R.strings.report_group_report,
    icon: <SvgMedicalExaminationFocusIcon />,
    pages:[
      {
        id: 21,
        labelI18nKey: R.strings.orthodontic_patient_list_zero_payment,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: DENTAL_TREATMENT_PATIENT_SCHEDULE_WITHOUT_PAID,
        isHideLabel: true,
        permission: FunctionPermissionEnum.READ_ORTHODONTIC_WITHOUT_PAID,
      },
      {
        id: 22,
        labelI18nKey: R.strings.orthodontic_patient_scheduling_density,
        updateAt: DateUtil.formatDDMMYYY(new Date()),
        path: DENTAL_TREATMENT_PATIENT_ORTHODONTIC_WITHOUT_PAID_PATH,
        isHideLabel: true,
        permission: FunctionPermissionEnum.READ_ORTHODONTIC_WITHOUT_PAID,
      },
    ],
  },
]
